module.exports = __webpack_public_path__ + "img/15dis2020-selgem-anugerah-geospatial-antarabangsa.0914f712.jpg";